module.exports = __webpack_public_path__ + "img/pr-10.44519d2e.png";